/**
 * running into an error using this dependency when building for production. commenting out until a fix is available
 *
 * ERROR in ../node_modules/@shopify/storefront-api-client/dist/umd/storefront-api-client.min.js 2:973
Module parse failed: Unexpected token (2:973)
You may need an appropriate loader to handle this file type, currently no loaders are configured to process this file. See https://webpack.js.org/concepts#loaders
 * This corresponds to the nullish coalescing operator in the following: {errors:e})=>e??[])

 */
// import {createStorefrontApiClient} from '@shopify/storefront-api-client';
// const client = createStorefrontApiClient({
//   storeDomain: `http://${window.Shopify.shop}`,
//   apiVersion: window.UNTUCKitConfig.shopifyStorefrontApiVersion,
//   publicAccessToken: window.UNTUCKitConfig.shopifyStorefrontApiPublicAccessToken
// });
// export function getStorefrontApiClient() {
//   return client;
// }
export async function storefrontApiRequest(query, variables) {
    try {
        const res = await fetch(`https://${window.Shopify.shop}/api/${window.UNTUCKitConfig.shopifyStorefrontApiVersion}/graphql`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": window.UNTUCKitConfig.shopifyStorefrontApiPublicAccessToken
            },
            body: JSON.stringify({
                query, variables
            })
        });
        return await res.json();
    }
    catch (err) {
        console.error(err);
    }
}
